export default function Checklist(props) {
    const data = props.list
    return <>
        <ul class={`checklists row ${props.class}`}>
            { data.map((e, i)=>{
                return <>
                <li className={props.col} key={i} >
                <div className={`checkmark ${props.liststyle} `} >
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.81295 7.24784C3.58895 7.24784 3.36495 7.16284 3.19395 6.99184L0.820953 4.61884C0.478953 4.27684 0.478953 3.72284 0.820953 3.38184C1.16295 3.03984 1.71595 3.03884 2.05795 3.38084L3.81295 5.13584L7.94095 1.00784C8.28295 0.665843 8.83595 0.665843 9.17795 1.00784C9.51995 1.34984 9.51995 1.90384 9.17795 2.24584L4.43195 6.99184C4.26095 7.16284 4.03695 7.24784 3.81295 7.24784Z" fill="white" />
                   </svg>
                </div>
                {e}</li>
                </>
            })}
        </ul>
    </>
}